import React from 'react';
export interface TimelineItem {
  id: string;
  title: string;
  description?: string;
  timestamp: string;
  icon?: React.ReactNode;
  status?: 'default' | 'success' | 'warning' | 'error' | 'info';
}
interface TimelineProps {
  items: TimelineItem[];
}
export const Timeline: React.FC<TimelineProps> = ({
  items
}) => {
  return <div className="relative border-l-2 border-border-light ml-3 space-y-8" data-id="element-241">
      {items.map(item => {
      const statusColors = {
        default: 'bg-surface-secondary border-border-strong text-text-secondary',
        success: 'bg-status-success-bg border-status-success text-status-success',
        warning: 'bg-status-warning-bg border-status-warning text-status-warning',
        error: 'bg-status-error-bg border-status-error text-status-error',
        info: 'bg-status-info-bg border-status-info text-status-info'
      };
      const colorClass = statusColors[item.status || 'default'];
      return <div key={item.id} className="relative pl-6" data-id="element-242">
            <div className={`absolute -left-[11px] top-1 w-5 h-5 rounded-full border-2 flex items-center justify-center bg-surface-primary ${colorClass}`} data-id="element-243">
              {item.icon && <span className="w-3 h-3 flex items-center justify-center" data-id="element-244">
                  {item.icon}
                </span>}
            </div>
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-baseline gap-1 mb-1" data-id="element-245">
              <h4 className="text-sm font-semibold text-text-primary" data-id="element-246">
                {item.title}
              </h4>
              <span className="text-xs text-text-tertiary whitespace-nowrap" data-id="element-247">
                {item.timestamp}
              </span>
            </div>
            {item.description && <p className="text-sm text-text-secondary" data-id="element-248">{item.description}</p>}
          </div>;
    })}
    </div>;
};